import { gql } from "lib/apolloClient";
import { identityUserFragment } from "modules/CommonFragments";
import { impersonationUserFragment } from "Login/modules/LoginFragments";

export const logoutUserMutation = gql`
  mutation logoutUser($input: LogoutUserInput!) {
    platform {
      logoutUser(input: $input) {
        isSuccess
        warning
      }
    }
  }
`;

export const addUserImpersonationMutation = gql`
  mutation addUserImpersonation($input: AddUserForImpersonationInput!) {
    platform {
      addUserImpersonation(input: $input) {
        isSuccess
        edge {
          node {
            ...identityUserBasicDetailsItem
          }
        }
        warning
      }
    }
  }
  ${identityUserFragment.basicDetails}
`;

export const removeUserImpersonationMutation = gql`
  mutation removeUserImpersonation(
    $input: RemoveUserFromMultiAccessIdentityInput!
  ) {
    platform {
      removeUserImpersonation(input: $input) {
        isSuccess
        edge {
          node {
            ...impersonationUserBasicDetailsItem
          }
        }
        warning
      }
    }
  }
  ${impersonationUserFragment.basicDetails}
`;
